export default __webpack_public_path__ + "static/media/navbar_home_icon.a6a4f351.svg";